/** @format */

/**
 *
 * @param {string} text
 * @returns {string|null}
 */
export function extractFirstStreetNumber(text) {
	const s = `${text ?? ''}`.trim();
	if (!s) return null;
	// Buscar el número al final del string (patrón estándar de dirección: "Calle Número")
	// Esto resuelve casos como "1 Ote. 1150" → "1150" o "14 de septiembre de 1928 33" → "33"
	const m = s.match(/(\d+)\s*$/);
	return m ? m[1] : null;
}
